import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=1504d88b&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504d88b",
  null
  
)

export default component.exports